import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { WrongIcon } from 'components/WrongIcon';
import { CompletedIcon } from 'components/CompletedIcon';

import { Radio } from 'components/shared/Radio';
import { Checkbox } from 'components/shared/Checkbox';
import { Typography } from 'components/shared/Typography';

import styles from './AnswerText.module.scss';

const AnswerText = ({
  submitted,
  correct,
  checked,
  answersMultiple,
  comment,
  data,
  previewType,
  isTestMode,
  onClick,
}: {
  submitted: any;
  correct: any;
  checked: any;
  answersMultiple: any;
  comment: any;
  data: any;
  previewType: any;
  isTestMode: any;
  onClick: any;
}) => (
  <div
    className={cn(styles.answer, {
      [styles.pluginAnswer]:
        previewType === getTranslation('common.text.plugin'),
      [styles.readOnlyAnswer]: !isTestMode,
      [styles.answerSelected]: checked,
      [styles.answerCorrect]:
        (checked && correct && submitted) || (!checked && correct && submitted),
      [styles.answerIncorrect]: checked && !correct && submitted,
      [styles.answerSubmitted]: submitted,
      [styles.answerSubmittedSelected]: submitted && checked,
    })}
    onClick={!submitted ? onClick : () => {}}
  >
    <div className={styles.inner}>
      {answersMultiple ? (
        <Checkbox
          className={styles.multipleType}
          readOnly
          checked={checked}
          disabled={submitted}
        />
      ) : (
        <Radio
          className={styles.multipleType}
          readOnly
          checked={checked}
          disabled={submitted}
        />
      )}
      <Typography className={styles.text} variant="body2" mode="compact">
        {data}
      </Typography>
      {isTestMode && (
        <CompletedIcon
          className={cn(styles.iconWrapper, styles.iconWrapperCorrect)}
          iconClassName={styles.iconCorrect}
        />
      )}
      {isTestMode && (
        <WrongIcon
          className={cn(styles.iconWrapper, styles.iconWrapperIncorrect)}
          iconClassName={styles.iconIncorrect}
        />
      )}
    </div>
    {comment &&
      ((checked && correct && submitted) ||
        (!checked && correct && submitted) ||
        (checked && !correct && submitted)) && (
        <Typography
          className={cn(styles.comment, {
            [styles.commentCorrect]:
              (checked && correct && submitted) ||
              (!checked && correct && submitted),
            [styles.commentIncorrect]: checked && !correct && submitted,
          })}
          variant="body2"
          mode="compact"
        >
          {comment}
        </Typography>
      )}
  </div>
);

export default React.memo(AnswerText) as any;
